<template>
  <transition name="fade">
    <div
      class="modal-container"
      v-if="show"
      tabindex="-1"
      role="dialog"
      @click="handleAllClicks"
    >
      <div class="modal vcore_container" ref="modal">
        <button
          class="modal-close"
          @click.stop="$emit('close')"
          @keydown.tab="tabClose"
          ref="closeButton"
          aria-label="Close Modal"
        >
          <i class="vcore_icon icon-close"></i>
        </button>
        <div class="modal-header vcore_row">
          <div class="vcore_col--xs--12">
            <h2 class="title" tabindex="-1">
              You can enroll for HSF<span class="sup">&reg;</span> with this
              provider only by contacting them directly.
            </h2>
          </div>
        </div>
        <div class="modal-body">
          <div class="vcore_row">
            <div class="vcore_col--xs--12">
              <p>
                We’ll let your provider know you requested the option to set up
                for online enrollment.
              </p>
              <p>
                For now, contact your provider to get started with your
                enrollment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ProviderNotEnrolledModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    provider: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleAllClicks(event) {
      if (!this.$refs["modal"].contains(event.target)) {
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sup {
  font-size: 70%;
  vertical-align: super;
}
body.modal-open {
  height: 100vh;
  overflow-y: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.modal-container {
  position: fixed;
  z-index: 2222;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);

  .modal {
    position: relative;
    max-width: 750px;
    margin: 0 auto;
    background-color: white;
    padding: 35px;
    top: 100px;
    // transform: translateY(-50%);
  }

  .modal-close {
    position: absolute;
    right: 17px;
    top: 14px;
    font-size: 20px;
    color: #666;
    cursor: pointer;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
  }

  .modal-header {
    margin-bottom: 25px;

    .title {
      font-weight: 400;
    }

    .sub-title {
      font-size: 0.875rem;
      margin-top: 15px;
      line-height: 1.1875rem;
    }
  }

  .modal-footer {
    margin-top: 25px;
  }
}
</style>
